<template>
  <Card>
    <h1 slot="Title">Internal Orders</h1>
    <div slot="MainContent">
      <p><b>Internal Orders (4500000001)</b>:  Cost objects used to plan, collect, monitor, and settle the costs of specific jobs and tasks. </p>
      <p class="mt-10">
        202011D20_  A76VV 131096QLOG 6100.2617 <b><u>4500000001</u></b> 1000000067 021001 
      </p>
    </div>  
    <p><strong>Internal Orders</strong></p>
    <p>Internal Orders:&nbsp; Cost objects used to plan, collect, monitor, and settle the costs of specific jobs and tasks.</p>
    <p>Internal Orders are used to monitor the costs of short term, long-term, and recurring activities or programs.</p>
  </Card>
</template>
<style scoped>


</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'InternalOrders',
  
  data() {
    return {
    }
  }
  
}
</script>